import React from 'react';
import { SxProps } from '@mui/material';
import {
    ColumnDatatable,
    FiltersDatatableList,
    PreFilterDatatableList,
    RowSelectionActionList,
    StoreDatatable,
} from '@europrocurement/flexy-datatable';
import { DataSource, getDataThunkType } from '@europrocurement/l2d-redux-utils';
import { DossierOpenSearch, useFormaliteService, useSociete } from '@europrocurement/l2d-domain';

export type DossierTableProps = {
    datasource: DataSource<DossierOpenSearch>;
    columns: ColumnDatatable<DossierOpenSearch>[];
    preFilters?: PreFilterDatatableList;
    filters: FiltersDatatableList;
    rowActions?: RowSelectionActionList;
    fetchData?: getDataThunkType<DossierOpenSearch>;
    onRowClick: (item: DossierOpenSearch) => void;
    onWheelClick: (item: DossierOpenSearch) => void;
};

const DossierTable: React.FunctionComponent<DossierTableProps> = function ({
    datasource,
    columns,
    preFilters,
    filters,
    rowActions,
    fetchData: customFetchData,
    onRowClick: handleRowClick,
    onWheelClick: handleRowWheelClick,
}) {
    const xIdSociete = useSociete();
    const { getOpenSearchDossiers: defaultGetOpenSearchDossiers } = useFormaliteService();

    // Utilise le fetchData personnalisé si fourni, sinon utilise le thunk par défaut
    const fetchData = customFetchData || defaultGetOpenSearchDossiers;

    return (
        <StoreDatatable
            dataSource={datasource}
            columns={columns}
            computeSxRow={(item: DossierOpenSearch) =>
                item.critical
                    ? ({
                          '&>td:first-of-type': {
                              borderLeft: '4px solid',
                              borderLeftColor: 'error.main',
                          },
                      } as SxProps)
                    : {}
            }
            computeSxRowHover={() => ({
                '.company-name': {
                    transition: 'color 0.25s ease',
                    color: 'primary.main',
                },
            })}
            fetchData={fetchData}
            localStorageKey="FlexyStoreDatatable"
            observers={[xIdSociete]}
            sx={{ marginBottom: '2.25em' }}
            preFilters={preFilters}
            filters={filters}
            onClickRow={(_: React.MouseEvent<HTMLElement>, item: DossierOpenSearch) => {
                handleRowClick(item);
            }}
            onWheelClickRow={(_: React.MouseEvent<HTMLElement>, item: DossierOpenSearch) => {
                handleRowWheelClick(item);
            }}
            rowsActions={rowActions}
        />
    );
};

export default DossierTable;
